// src/routes/ProtectedRoute.jsx
import { Navigate, useLocation } from "react-router-dom";
import { useAuth } from "../context/AuthContext";
import { FormSkeleton } from "../components/skeletons/ShopperSkeletons";

/**
 * ProtectedRoute
 *
 * - Redirects unauthenticated users to /login
 * - Preserves intended destination in state
 * - Works for nested routes (like /account/*)
 * - Safe for mobile-first + SPA navigation
 */

export default function ProtectedRoute({ children }) {
  const { isAuthenticated, loading } = useAuth();
  const location = useLocation();

  // Optional: handle auth loading state
  if (loading) {
    return (
      <div className="mx-auto w-full max-w-4xl px-4 py-8 sm:px-6">
        <FormSkeleton sections={2} label="Checking shopper session" />
      </div>
    );
  }

  // If NOT authenticated → redirect to login
  if (!isAuthenticated) {
    return (
      <Navigate
        to="/login"
        replace
        state={{
          from: location.pathname + location.search,
        }}
      />
    );
  }

  // Authenticated → render children
  return children;
}
